// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfi_a bii_bj"};